import {LinkedInIcon, PayPalIcon, WhatsAppIcon} from "./icons";
import {Headshot} from "../../components/images";

export function ContactPage() {
  return <div className={"w-[100mvw] flex flex-col items-center"}>
    <div className={"w-full max-w-[85vw] min-h-screen flex flex-col items-center justify-center"}>
      <div className={"flex flex-col gap-4 max-w-md w-full"}>
        <div className={"flex flex-col items-center justify-center mb-10"}>
          <Headshot className={"w-32 h-32 rounded-full drop-shadow-glow-primary border-primary/20 border-4"}/>
          <h3 className={"mt-4"}>Moritz Bruder</h3>
          <a href={"mailto:moritz@mbruder.com"}
             className={"text-primary font-medium hover:underline"}>moritz@mbruder.com</a>
        </div>
        <ServiceLink name={"WhatsApp"} color={"#075e54"} icon={WhatsAppIcon} url={"https://wa.me/491633260994"}/>
        <ServiceLink name={"PayPal"} color={"#003087"} icon={PayPalIcon} url={"https://paypal.me/moritzbruder"}/>
        <ServiceLink name={"LinkedIn"} color={"#0a66c2"} icon={LinkedInIcon} url={"https://linkedin.com/in/moritzbruder"}/>
      </div>
    </div>
  </div>
}

function ServiceLink(props: {
  name: string;
  icon: typeof WhatsAppIcon;
  url: string;
  color: string;
}) {
  const Icon = props.icon;
  return <a href={props.url}>
    <div style={{backgroundColor: props.color}}
         className={`flex flex-row items-center gap-4 p-3 justify-center font-semibold rounded-xl cursor-pointer transition-all duration-300 hover:scale-[99%]`}>
      <Icon className={"w-7 h-7"}/>
      {props.name}
    </div>
  </a>
}